import { mergeProps, useRender } from '@base-ui/react';
import { useTranslation } from 'react-i18next';

import { Icon } from '~/components';
import { srOnlyStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import {
  boxStyle,
  checkedIconStyle,
  checkedLabelStyle,
  contentStyle,
  headerStyle,
  labelStyle,
  lockedStyle,
  textStyle,
  uncheckedStyle,
  wrapperStyle,
} from './AccountCompletionCheckbox.css';

type Props = Omit<useRender.ComponentProps<'div'>, 'children'> & {
  checked: boolean;
  label: string;
  locked?: boolean;
  text?: string;
};

export const AccountCompletionCheckbox = ({ checked, label, locked, render, text, ...delegated }: Props) => {
  const { t } = useTranslation(['dashboard']);

  const children = (
    <>
      <div className={headerStyle}>
        <div className={clsx(boxStyle, checked && checkedIconStyle)}>{checked && <Icon name="Check" />}</div>

        <div className={contentStyle}>
          <p className={clsx(labelStyle, checked && checkedLabelStyle)}>
            <span className={srOnlyStyle}>
              {checked ? t('dashboard:progression.steps.completed') : t('dashboard:progression.steps.uncompleted')}
            </span>

            {label}
          </p>

          {text && <p className={textStyle}>{text}</p>}
        </div>
      </div>

      {!checked && (locked ? <Icon name="Lock" /> : <Icon name="ChevronForward" />)}
    </>
  );

  const element = useRender({
    defaultTagName: 'div',
    render: checked ? undefined : render,
    props: mergeProps<'div'>(
      {
        children,
        className: clsx(wrapperStyle, !checked && !locked && uncheckedStyle, locked && lockedStyle),
      },
      delegated,
    ),
  });

  return <li>{element}</li>;
};
